import { render, staticRenderFns } from "./LandingBirthdayDE.vue?vue&type=template&id=3d9b5be2"
import script from "./LandingBirthdayDE.vue?vue&type=script&lang=js"
export * from "./LandingBirthdayDE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports